import { Container, Row } from 'src/components-v2/Layout';
import Header from './Header';
import FaqTable from './FaqTable';
import { FaqProps } from './Faq.types';

const Faq: React.FC<FaqProps> = ({
  body,
  faqItems,
  includeFaqSchema = false,
}) => {
  return (
    <Container>
      <Row>
        <Header>{body}</Header>
        <FaqTable faqItems={faqItems} includeFaqSchema={includeFaqSchema} />
      </Row>
    </Container>
  );
};

export default Faq;
